import React, { ReactNode, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAuth } from 'contexts/AuthContext';


const NavigationWrapper = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const {user, firebaseUser, subscriptionStatus, loading } = useAuth();
  

  useEffect(() => {
    if(!firebaseUser) {
      navigate('/login');
    }
    else if (!user && !loading) {
      navigate('/create');
    }
    else if (!subscriptionStatus && !loading) {
      navigate('/subscribe');
    }
    else if (!loading) {
      navigate('/account', {state:{signupMethod: subscriptionStatus?.signupMethod}});
    }

  }, [user, firebaseUser, subscriptionStatus, loading]);

  return (
    <>{children}</>
  );
};

export { NavigationWrapper };
